import { useState, useEffect } from 'react';
import CollapsibleDataTable from './TableWithCollapsibleRows';
import { useParams } from 'react-router-dom';
import { getOrderHistoryByOrderId, getOrderInfoForPatient } from '../service';
import moment from 'moment';
import { useAuth } from 'react-oidc-context';
import { OrderHistoryData, PatientOrderInfo } from '../interface/interface';
import Loading from './Loading';
import PatientPrimaryInfo from './PatientPrimaryInfo';
import Breadcrumbs from './Breadcrumbs';

const visibleColumns = ['Date', 'Time', 'Status', 'Updated By'];
const hiddenColumns: string[] = [];
const OrderHistory = () => {
  const { orderId } = useParams();
  const { user } = useAuth();

  const [orderTrackingData, setOrderTrackingData] = useState<
    OrderHistoryData[]
  >([]);
  const [invoiceId, setOrderInvoiceId] = useState<number>();

  const [patientDetail, setPatinetDetail] = useState<PatientOrderInfo>();

  const [patientDataLoading, setPatinetDataLoading] = useState(false);
  const [orderHistoryLoading, setOrderHistoryLoading] = useState(false);

  useEffect(() => {
    if (isNaN(Number(orderId))) return;
    setOrderHistoryLoading(true);
    getOrderHistoryByOrderId(Number(orderId), user?.access_token)
      .then((res) => {
        console.log(res);
        setOrderTrackingData(
          res.data.map((ele: any) => ({
            Date: moment(ele.createdDate).format('DD/MM/YYYY'),
            Time: moment(ele.createdDate).format('hh:mm'),
            Status: ele.isResumed
              ? `Resumed to - ${ele.orderStatus.name}`
              : ele.orderStatus.name,
            'Updated By': ele.modifiedBy
              ? ele.modifiedBy.first_name + ' ' + ele.modifiedBy.last_name
              : null,
          })),
        );

        setOrderInvoiceId(res?.data[0]?.order.invoiceId);
        setOrderHistoryLoading(false);
      })
      .catch((err) => {
        setOrderHistoryLoading(false);
        console.log(err);
      });
  }, [orderId]);

  useEffect(() => {
    if (!orderId || !user?.access_token || isNaN(Number(orderId))) return;
    setPatinetDataLoading(true);
    getOrderInfoForPatient(user.access_token, Number(orderId))
      .then((data) => {
        setPatinetDetail(data);
        setPatinetDataLoading(false);
      })
      .catch((err) => {
        setPatinetDataLoading(false);
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  if (patientDataLoading || orderHistoryLoading) {
    return <Loading />;
  }

  return (
    <>
      <Breadcrumbs
        data={[
          {
            tag: 'a',
            href: '/admin/orders',
            children: <>Orders</>,
          },
          {
            tag: 'a',
            href: `/order-summary/${orderId}`,
            children: <> Order summary #{invoiceId}</>,
          },
          {
            tag: 'p',
            children: <span>Order History</span>,
          },
        ]}
      />
      <h2 className="text-xl md:text-2xl text-primary-blue-500 pb-5 font-semibold">
        Order History for{' '}
        <span className="text-secondary-pink-600">#{invoiceId ?? '-'}</span>
      </h2>
      {patientDetail && (
        <PatientPrimaryInfo
          patient={{ ...patientDetail, id: patientDetail.patientId }}
        />
      )}

      <div className="bg-white p-10 rounded-md shadow mt-10">
        <h2 className="text-2xl text-primary-blue-500 font-semibold mb-11">
          Order tracking{' '}
          {invoiceId && (
            <span className="text-secondary-pink-600 ml-6">#{invoiceId}</span>
          )}
        </h2>
        <CollapsibleDataTable
          data={orderTrackingData}
          visibleColumns={visibleColumns}
          hiddenColumns={hiddenColumns}
          className="order-history-table"
        />
      </div>
    </>
  );
};

export default OrderHistory;
